import { useEffect, useRef, useState } from "react";
import {
  FaHeart,
  FaCalendarAlt,
  FaClock,
  FaMapMarkerAlt,
  FaVolumeUp,
  FaVolumeMute,
  FaTshirt,
} from "react-icons/fa";
import { GiQueenCrown } from "react-icons/gi";
import { BsStars } from "react-icons/bs";
import { Helmet } from "react-helmet-async";
import "./BirthdayInvitation.css";

import eleanorPhoto from "../img/cumple/main.webp";

import collage1 from "../img/cumple/dayaplaya.webp";
import collage2 from "../img/cumple/ultra.webp";
import collage3 from "../img/cumple/niniadormidameses.webp";
import collage4 from "../img/cumple/niniadormida.webp";
import collage5 from "../img/cumple/niniarosa.webp";
import collage6 from "../img/cumple/niniavestidorosa.webp";
import collage7 from "../img/cumple/niniaazul.webp";
import collage8 from "../img/cumple/niniacontulipan.webp";
import collage9 from "../img/cumple/niniapatio.webp";
import collage10 from "../img/cumple/niniadiez.webp";
import collage11 from "../img/cumple/conbay.webp";
import collage12 from "../img/cumple/lago.webp";

import birthdaySong from "../audio/cancion.mp3";

const collagePhotos = [
  collage1,
  collage2,
  collage3,
  collage4,
  collage5,
  collage6,
  collage7,
  collage8,
  collage9,
  collage10,
  collage11,
  collage12,
];

const eventAddress = "8841 NW 14th St, Pembroke Pines, FL 33024";

const googleMapsUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
  eventAddress
)}`;

function Bunny({ side }) {
  return (
    <div className={`side-bunny bunny-${side}`}>
      <div className="bunny-ears">
        <span></span>
        <span></span>
      </div>

      <div className="bunny-face">
        <div className="css-crown bunny-crown">
          <span></span>
          <span></span>
          <span></span>
        </div>

        <div className="mini-bow">
          <i></i>
          <b></b>
          <i></i>
        </div>

        <div className="eyes">
          <span></span>
          <span></span>
        </div>

        <div className="nose"></div>
        <div className="smile">ω</div>
      </div>
    </div>
  );
}

function BirthdayInvitation() {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [showMusicButton, setShowMusicButton] = useState(false);

  const playMusic = async () => {
    if (!audioRef.current) return;

    try {
      audioRef.current.volume = 0.35;
      await audioRef.current.play();
      setIsPlaying(true);
      setShowMusicButton(false);
    } catch (error) {
      setIsPlaying(false);
      setShowMusicButton(true);
      console.log("La reproducción automática fue bloqueada:", error);
    }
  };

  const pauseMusic = () => {
    if (!audioRef.current) return;

    audioRef.current.pause();
    setIsPlaying(false);
    setShowMusicButton(true);
  };

  const toggleMusic = (event) => {
    event.stopPropagation();

    if (isPlaying) {
      pauseMusic();
    } else {
      playMusic();
    }
  };

  useEffect(() => {
    playMusic();
  }, []);

  return (
    <main
      className="invitation-page"
      onClick={!isPlaying ? playMusic : undefined}
    >
      <Helmet>
        <title>Primer Cumpleaños de Eleanor</title>

        <meta
          name="description"
          content="Estás invitado al primer cumpleaños de Eleanor. Una celebración mágica en tonos rosados, llena de amor, moños, conejitos y recuerdos especiales."
        />

        <meta property="og:title" content="Primer Cumpleaños de Eleanor" />
        <meta
          property="og:description"
          content="Estás invitado al primer cumpleaños de Eleanor. Acompáñanos en una celebración mágica llena de amor y dulces recuerdos."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://charmieskastle.com/cumpleanioseleanor"
        />
        <meta
          property="og:image"
          content="https://charmieskastle.com/eleanor-preview.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Primer Cumpleaños de Eleanor" />
        <meta
          name="twitter:description"
          content="Estás invitado al primer cumpleaños de Eleanor."
        />
        <meta
          name="twitter:image"
          content="https://charmieskastle.com/eleanor-preview.png"
        />
      </Helmet>

      <audio
        ref={audioRef}
        src={birthdaySong}
        loop
        autoPlay
        preload="auto"
        playsInline
        onEnded={() => {
          if (audioRef.current) {
            audioRef.current.currentTime = 0;
            audioRef.current.play();
          }
        }}
      />

      {showMusicButton && (
        <button className="music-btn" type="button" onClick={toggleMusic}>
          {isPlaying ? <FaVolumeUp /> : <FaVolumeMute />}
          <span>{isPlaying ? "Música activa" : "Reproducir música"}</span>
        </button>
      )}

      <section className="invite-card">
        <div className="floating-shapes" aria-hidden="true">
          <span className="shape crown crown-1">
            <GiQueenCrown />
          </span>

          <span className="shape crown crown-2">
            <GiQueenCrown />
          </span>

          <span className="shape heart heart-1">
            <FaHeart />
          </span>

          <span className="shape heart heart-2">
            <FaHeart />
          </span>

          <span className="shape heart heart-3">
            <FaHeart />
          </span>

          <span className="shape star star-1">
            <BsStars />
          </span>

          <span className="shape star star-2">
            <BsStars />
          </span>

          <span className="shape star star-3">
            <BsStars />
          </span>
        </div>

        <div className="balloons" aria-hidden="true">
          <span className="balloon balloon-1"></span>
          <span className="balloon balloon-2"></span>
          <span className="balloon balloon-3"></span>
          <span className="balloon balloon-4"></span>
          <span className="balloon balloon-5"></span>
          <span className="balloon balloon-6"></span>
        </div>

        <div className="top-ribbon">
          <span></span>

          <div className="css-bow">
            <i></i>
            <b></b>
            <i></i>
          </div>

          <span></span>
        </div>

        <div className="invite-header">
          <p className="invite-kicker">Estás invitado al</p>

          <h1>Eleanor</h1>

          <div className="birthday-badge">
            <GiQueenCrown />
            <span>Mi Primer Añito</span>
            <GiQueenCrown />
          </div>

          <p className="invite-message">
            Un día mágico para celebrar a nuestra pequeña princesa
          </p>
        </div>

        <div className="gift-note">
          <FaHeart />

          <div>
            <span>Una pequeña nota</span>
            <p>
              Tu presencia es el regalo más especial. Si deseas traer un detalle,
              un regalo en sobre será recibido con mucho cariño.
            </p>
          </div>
        </div>

        <div className="photo-scene">
          <Bunny side="left" />

          <div className="photo-frame">
            <div className="photo-crown css-crown">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div className="photo-inner">
              <img src={eleanorPhoto} alt="Eleanor" />
            </div>

            <div className="frame-bow mini-bow">
              <i></i>
              <b></b>
              <i></i>
            </div>
          </div>

          <Bunny side="right" />
        </div>

        <div className="event-info">
          <div className="info-item">
            <div className="info-icon">
              <FaCalendarAlt />
            </div>

            <div>
              <span>Fecha</span>
              <strong>Domingo 19 de julio</strong>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">
              <FaClock />
            </div>

            <div>
              <span>Hora</span>
              <strong>6:30 PM</strong>
            </div>
          </div>

          <div className="info-item">
            <div className="info-icon">
              <FaMapMarkerAlt />
            </div>

            <div>
              <span>Lugar</span>
              <strong>Casa de Eleanor</strong>

              <a
                className="map-button"
                href={googleMapsUrl}
                target="_blank"
                rel="noreferrer"
                onClick={(event) => event.stopPropagation()}
              >
                Presiona aquí para obtener la dirección
              </a>
            </div>
          </div>
        </div>

        <div className="dress-code-card">
          <div className="dress-code-icon">
            <FaTshirt />
          </div>

          <div>
            <span>Código de vestimenta</span>
            <strong>Rosado</strong>
            <p>
              Te invitamos a vestir algo rosado para combinar con la dulce
              celebración de Eleanor.
            </p>
          </div>
        </div>

        <div className="collage-section">
          <div className="collage-heading">
            <span>Pequeños recuerdos</span>
            <h2>Dulces momentos con Eleanor</h2>
            <p>Algunos recuerdos especiales de su primer añito.</p>
          </div>

          <div className="collage-grid">
            {collagePhotos.map((photo, index) => (
              <div
                className={`collage-photo collage-photo-${index + 1}`}
                key={`collage-${index + 1}`}
              >
                <img src={photo} alt={`Recuerdo de Eleanor ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>

        <div className="invite-footer">
          <span></span>
          <p>¡Nos encantará celebrar este día contigo!</p>
          <span></span>
        </div>
      </section>
    </main>
  );
}

export default BirthdayInvitation;